import * as React from 'react';
import { SeoMortgageLink as SeoMortgageLinkComponent } from '../../components/SeoMortgageLink';
import { psevdoExperiment2023Q3Selector } from '../../selectors/experiments/controlExperiments';
import { useSelector } from 'react-redux';
import { mortgageSeoPageUrlSelector, mortgageSeoPageActiveSelector } from '../../selectors/seoPages';
import { trackMortgageOffersTabClick } from '../../analytics/promos';
import { EMortgageOffersTabs } from '../../types/mortgageOffers';

export const SeoMortgageLink = () => {
  const isInControlGroup = useSelector(psevdoExperiment2023Q3Selector);
  const url = useSelector(mortgageSeoPageUrlSelector);
  const isPageActive = useSelector(mortgageSeoPageActiveSelector);

  const onClick = React.useCallback(() => {
    trackMortgageOffersTabClick(EMortgageOffersTabs.SeoUrl);
  }, []);

  if (!isInControlGroup || !isPageActive) {
    return null;
  }

  return (
    <SeoMortgageLinkComponent
      url={url}
      onClick={onClick}
      title="Ипотечные предложения и аккредитованные банки"
      testId="seo_mortgage_link"
    />
  );
};
